export const Base_URL = "https://api.themoviedb.org/3";
export const API_key = "api_key=44215a69b2337d878932ea0a9d2088d4";
